import { useContent } from '../../../../hooks/use-server-content';

export interface ExemptWordsListProps {
    exemptUpperCaseWords: string[];
    exemptCapitalWords: string[];
}

export const useExemptWordsContent = (): ExemptWordsListProps | null => {
    const [content, getValueByName] = useContent(
        'recalls',
        'exempt-words-list'
    );
    let contentFragment: any = {};

    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    if (contentFragment) {
        if (
            !contentFragment.exemptUpperCaseWords &&
            !contentFragment.exemptCapitalWords
        ) {
            contentFragment = null;
        }
    }

    return contentFragment as ExemptWordsListProps;
};
